import { useAppConfig } from '@plato/app-core/hooks/use-app-config';
import { toErpServiceAddress } from '@plato/data/model/address';
import type { ReactElement } from 'react';
import { getAddressKey, getFullAddressString } from '../../../lib/address-helper.ts';
import { api } from '../../../utils/api.ts';
import { SearchSelect } from './search-select.tsx';

export type AddressInputProps = {
    customerId: string | undefined;
    disabled?: boolean;
    name: 'billing_address_id' | 'shipping_address_id';
    onChange?: (id: string) => void;
    placeholder?: string;
    value?: string;
};

export function AddressInput({
    customerId,
    disabled,
    name,
    onChange,
    placeholder,
    value,
}: AddressInputProps): ReactElement {
    const { transactionDraftRestrictShippingAddressTypes, transactionDraftRestrictBillingAddressTypes } =
        useAppConfig();

    const { data: addressList, isLoading: isAddressListLoading } =
        api.platoUser.getManyCustomerAddress.get.useQuery(
            {
                customerId: customerId ?? '',
                types:
                    name === 'shipping_address_id'
                        ? transactionDraftRestrictShippingAddressTypes
                        : transactionDraftRestrictBillingAddressTypes,
            },
            {
                enabled: !!customerId,
                select: (data) => data.map(toErpServiceAddress),
            },
        );

    return (
        <SearchSelect
            disabled={disabled}
            items={addressList}
            idSelector={getAddressKey}
            isLoading={isAddressListLoading}
            onSelectedIdChange={onChange}
            placeholder={placeholder}
            renderItem={getFullAddressString}
            selectedId={value}
            textSelector={getFullAddressString}
        />
    );
}
